export { PluginHeaderInfo } from './PluginHeaderInfo.component';
